import * as React from "react";

import "./unaddressed-copies-ui.scss";

import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";

export const UnaddressedCopiesUi = ({enabled, quantityUi, renderAddressSection}) => (
    <div className="unaddressed-copies-ui-3r1">
        <div {...{
            className: "title",

            "xd-qa-type": "label",
            "xd-qa-name": "Additional Shipped Copies",
        }}>
            Additional Shipped Copies
        </div>

        <div className="box">
            <div className="shipping-details">
                <div className="header">
                    <div {...{
                        className: "title",

                        "xd-qa-type": "label",
                        "xd-qa-name": "Ship additional copies of my mailed order",
                    }}>
                        Ship additional copies of my mailed order
                    </div>
                    {SliderCheckbox({
                        ...enabled,
                        xdQaName: "Ship additional copies of my mailed order",
                    })}
                </div>

                <div className="quantity-box">
                    <div {...{
                        className: "label",

                        "xd-qa-type": "label",
                        "xd-qa-name": "Additional copies",
                    }}>
                        Additional copies
                    </div>
                    {quantityUi}
                </div>


                {/*<div className="cb-section confirm-shipping-address">*/}
                {/*    {Checkbox({*/}
                {/*        checked: true,*/}
                {/*    })}*/}
                {/*    <div className="title">*/}
                {/*        Confirm Shipping Address*/}
                {/*    </div>*/}

                {/*    <div className="address-box">*/}
                {/*        <div className="line">*/}
                {/*            1301 NE Loop 820,*/}
                {/*        </div>*/}
                {/*        <div className="line">*/}
                {/*            Fort Worth, TX 76131*/}
                {/*        </div>*/}
                {/*        <a>*/}
                {/*            Edit*/}
                {/*        </a>*/}
                {/*    </div>*/}
                {/*</div>*/}

            </div>


            {enabled.value && (
                <div className="cb-section address">
                    {renderAddressSection()}
                </div>
            )}
        </div>
    </div>
);
